import React from "react";
import "./skeleton.css";

const Skeleton = ({
  width = "100%",
  height = "20px",
  borderRadius = "8px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default Skeleton;